// extracted by mini-css-extract-plugin
export var item = "project-module--item--Ft2QC";
export var project = "project-module--project--fwL+J";